import {
    FeatureType,
    MatrixType,
    getFeatureApiType,
    updateFeatureApiType,
} from '@/interfaces/AccessInterface';

import axios from '@/config/AxiosConfig';

export const getFeature: getFeatureApiType = async () => {
    const { data } = await axios.get('/api/role/access/all');
    return data.data as unknown as FeatureType;
};

export const editFeature: updateFeatureApiType = async (params: { matrix: MatrixType }) => {
    const { status } = await axios.post('/api/role/access/add', params);
    return status as unknown as number;
};

export const getAccess = async (id: string) => {
    const res = await axios.get(`/api/role/${id}/access`);
    return res;
};
